import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.critical;

export const getCriticalPlansSelector = createSelector(getState, (state) => state.criticalPlans);
